import { render, staticRenderFns } from "./SeckillPage.vue?vue&type=template&id=e60ea180&scoped=true"
import script from "./SeckillPage.vue?vue&type=script&lang=js"
export * from "./SeckillPage.vue?vue&type=script&lang=js"
import style0 from "./SeckillPage.vue?vue&type=style&index=0&id=e60ea180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60ea180",
  null
  
)

export default component.exports